const state = {
  journey: [
    'details', 'address', 'terms', 'payment', 'confirm'
  ]
};

const getters = {};

const actions = {};

const mutations = {
  updateState (state, { prop, value }) {
    state[prop] = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

function removeFromArray (array, removeList) {
  return array.filter(item => removeList.indexOf(item.q) === -1);
}
